import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';
import '../styles/NltxDocuments.css'
import ChartDonut from '../js/ChartDonut';
import ChartLine from '../js/ChartLine';

export default function NltxDocuments() {
    useEffect(() => {
        document.title = "Analytics | Documents"; // Set the tab name
    }, []);

    const [dataCounts, setDataCounts] = useState({
        documentsTotal: 0,
        documentsNew: 0,
        documentsAttached: 0,
        documentsArchived: 0
    });

    const [updateTrigger, setUpdateTrigger] = useState(false);
    
    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };

    useEffect(() => {
        const fetchDataCounts = async () => {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); // TODO refer to api folder in htdocs
            setDataCounts({
              documentsTotal: abbreviateNumber(response.data.documentsTotal),
              documentsNew: abbreviateNumber(response.data.documentsNew),
              documentsAttached: abbreviateNumber(response.data.documentsAttached),
              documentsArchived: abbreviateNumber(response.data.documentsArchived)
            });
          } catch (error) {
            //console.error("Error fetching data counts:", error);
          }
        };
    
        fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };     

    const navigate = useNavigate();

    const data1 = [
        {date: new Date("2024-06-01"), value: 30},
        {date: new Date("2024-07-01"), value: 70},
        {date: new Date("2024-08-01"), value: 92}
    ]

    const data2 = [
        {date: new Date("2024-06-01"), value: 44},
        {date: new Date("2024-07-01"), value: 64},
        {date: new Date("2024-08-01"), value: 79}
    ]

    return (
        <div>
        <div className="analytics-heading">
            <strong className='text'>Document Analytics</strong>
        </div>
        <section className='dash_overview'>
            <article className='stat_box standalone'>
                <h6 className='title analytics-card' analytics-card>Total&nbsp;Documents&nbsp;In&nbsp;Database</h6>
                <p className='title body analytics-card'>{dataCounts.documentsTotal}</p>
            </article>

            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>New&nbsp;Documents</h6>
                <p className='title body analytics-card'>{dataCounts.documentsNew}</p>
            </article>

            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>Documents&nbsp;Attached&nbsp;In&nbsp;Requests</h6>
                <p className='title body analytics-card'>{dataCounts.documentsAttached}</p>
            </article>

            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>Archived&nbsp;Documents</h6>
                <p className='title body analytics-card'>{dataCounts.documentsArchived}</p>
            </article>
        </section>

        <section className='dash_overview' style={{ marginTop: '20px' }}>
        <article className='stats'>
            <h5 className='title'>Top Requested Documents</h5>
            <article className='stat_box'>
                <ChartDonut/>
            </article>
        </article>
        
        <article className='stats'>
            <h5 className='title'>Document Uploads VS Archived</h5>
            <article className='stat_box'>
                <ChartLine dataProps1={data1} dataProps2={data2} nameProps1='Uploads' nameProps2='Archived' />
            </article>
        </article>
        </section>
    </div>
    )
}